const DEFAULT_COUNT = 0;

function parse(number, float) {
  if (float) {
    return parseFloat(number) || 0;
  }

  return parseInt(String(number).replace(/[^0-9-]/g, ''), 10) || 0;
}

export default function lessThan(value = '', options = {}) {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  const {
    count,
    equal,
    float,
  } = options;

  const min = parse(count || DEFAULT_COUNT, float);
  const number = parse(value, float);

  if ((equal && number <= min) || number < min) {
    return false;
  }

  return true;
}

lessThan.message = function message(value, options = {}) {
  const {
    count,
    equal,
    formatter,
  } = options;

  const max = count || DEFAULT_COUNT;
  const format = formatter || (number => number);
  const prefix = equal ? 'precisa ser menor ou igual a' : 'precisa ser menor que';

  return options.message || `${prefix} ${format(max)}`;
};
